import type { Address } from '@/types';

interface GetDiffShippingAddressIdProps {
  deliveryAddresses: Address[];
  storedAddressIds: string[];
}

export const getDiffShippingAddressId = ({
  deliveryAddresses,
  storedAddressIds,
}: GetDiffShippingAddressIdProps) =>
  deliveryAddresses.find(({ id }) => id && !storedAddressIds.includes(id))?.id;
